import { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useWizardHandler } from "../../modules/WizardHandler";
import WizardStepForm from "./WizardStepForm";

const WizardStepConfigurator = () => {
  const { wizardStep } = useParams();
  const navigate = useNavigate();
  //const globalData = useGlobalData();

  const wizardHandler = useWizardHandler();

  const didRedirect = useRef(false);

  if (!wizardStep) return <>Not found</>;
  const step = parseInt(wizardStep);
  if (step < 1) return <>Not found</>;

  const building = wizardHandler.getWizardBuilding(); //buildingId ? globalData.buildings?.find((b) => b.id === parseInt(buildingId)) : undefined;
  if (!building) return <>Not found</>;

  const wizardDefaultValues = wizardHandler.getWizardBuildingDefaultData();

  const cancelConfiguration = () => {
    if (didRedirect.current) return;
    didRedirect.current = true;
    navigate("../..");
  };

  return <WizardStepForm building={building} wizardStep={step} defaultData={wizardDefaultValues} cancelConfiguration={cancelConfiguration}></WizardStepForm>;
};

export default WizardStepConfigurator;
